export default "__VITE_PUBLIC_ASSET__19cf5a21__"